<div class="car-jobs pb-3">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="row">  
                    <div class="col-xl-1 col-md-2 pt-2">
                        <h6 class="mb-md-0 mb-2">Regional</h6>
                    </div>
                    <div class="col-xl-3 col-md-4">
                        <div class="select-ver3"  *ngIf="dataRegional.length != 0">
                            <ng-select2
                                [data]="dataRegional" 
                                placeholder="{{ regional.text }}"
                                (valueChanged)="selectRegional($event)">
                            </ng-select2>
                        </div>
                        <div class="select select-ver3" *ngIf="dataRegional.length == 0">
                            <ng-select2
                                [data]="dataRegional" 
                                placeholder="{{ isLang?.chooseOne }}"
                                (valueChanged)="selectRegional($event)">
                            </ng-select2>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <h3 class="f-mtit py-4 my-2">{{ isLang?.availablePosition }}</h3>
                        <div *ngIf="dataPerRegional?.length != 0 && !loadingData">
                            <div class="accordion-grey">
                                <accordion [isAnimated]="true">
                                    <accordion-group *ngFor="let job of dataPerRegional ; let key = index">
                                        <div class="title d-block pr-5" accordion-heading>
                                             <div class="d-md-flex justify-content-between">
                                                 <div class="w-posi pr-md-3">
                                                     <small>{{ isLang?.position }}</small>
                                                     <h6 class="mt-1">{{ job.title }}</h6>
                                                 </div>
                                                 <div class="w-loca">
                                                    <small>{{ isLang?.location }}</small>
                                                    <h6 class="mt-1">{{ regional.text  }}</h6>
                                                </div>
                                                <div class="w-date pl-md-3">
                                                    <small>{{ isLang?.closedDate }}</small>
                                                    <h6 class="mt-1">{{ job.end_date | date:'dd' }} - {{ job.end_date | date:'MMMM yyyy' }}</h6>
                                                </div>
                                             </div>
                                             <span class="icon"><i class="icon ion-ios-arrow-down"></i></span>
                                        </div>
                                        <div class="desc" [innerHTML]="job.description"></div>
                                        <div class="row mt-5">
                                            <div class="col-lg-3 col-md-4 col-9 mx-auto">
                                                <a (click)="apply(regional.id, job.id)" class="btn more red-btn w-100">Apply</a>
                                            </div>
                                        </div>
                                    </accordion-group>
                                </accordion>
                            </div>
                        </div>
                        <div *ngIf="loadingData"
                            style="height: 250px"
                            class="d-flex align-items-center justify-content-center w-100">
                            <div class="spinner-border text-dark" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div *ngIf="dataPerRegional?.length == 0 && !loadingData" 
                            style="height: 250px"
                            class="d-flex align-items-center justify-content-center w-100">
                            <h6>{{ isLang?.noData }}</h6>
                        </div>
                    </div>
                    <div class="col-md-12 mt-5">
                        <div class="career-box"[ngStyle]="{backgroundImage:'url(./assets/images/banner/career-box.png)'}">
                            <h4>{{ isLang?.dropCV }}</h4>
                            <a routerLink="/career/form-job" class="btn btn-primary btn-drop">{{ isLang?.buttonCV }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
     <!-- modal danger -->
    <div *ngIf="isModalDanger" 
        [config]="{ show: true }" 
        (onHidden)="onHidden()" 
        bsModal 
        #autoShownModal="bs-modal"
        class="modal fade danger-pop"
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="dialog-auto-name">
        <div class="modal-dialog  d-flex align-items-center py-4 my-0 h-100 modal-md">
            <div class="modal-content">
                <div class="modal-x" aria-label="Close" (click)="hideModal()">
                    <span aria-hidden="true"><i class="icon ion-ios-close"></i></span>
                </div>
                <div class="icon-seru">
                    <img src="../../../assets/images/icon/seru-icon.svg" width="100%" alt="">
                </div>
                <!--<div class="modal-body">
                    <h5>{{ dataSection[0]?.title }}</h5>
                    <div class="mt-3" [innerHTML]="dataSection[0]?.content"></div>
                </div>-->
                <!--added by steven (temporary solution / hardcode)-->
                <div class="modal-body">
                    <h5>{{ isLang?.modalTitle }}</h5>
                    <div class="mt-3">{{ isLang?.modalContent }}</div>
                </div>
                <!--end added by steven (temporary solution / hardcode)-->
            </div>
        </div>
    </div>
</div>



